<template>
  <div class="random-group-container">
    <el-card class="random-group-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">随机分组</span>
      </div>
      <div class="random-group-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="input-card" shadow="hover">
              <el-form :model="groupForm" :rules="groupRules" ref="groupForm" label-width="100px">
                <el-form-item label="选手名称" prop="players">
                  <el-input
                    v-model="groupForm.players"
                    type="textarea"
                    :rows="10"
                    placeholder="请输入选手名称，每行一个"
                    resize="vertical"
                  ></el-input>
                  <div style="margin-top: 10px; color: #909399; font-size: 12px;">
                    <span>示例：</span>
                    <el-tag size="small" effect="plain">泡沫</el-tag>
                    <el-tag size="small" effect="plain">秋天的童话</el-tag>
                    <el-tag size="small" effect="plain">其他选手</el-tag>
                  </div>
                </el-form-item>
                <el-form-item label="分组数量" prop="groupCount">
                  <el-input-number
                    v-model="groupForm.groupCount"
                    :min="1"
                    :max="20"
                    :step="1"
                    placeholder="请输入分组数量"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="generateGroups" :loading="loading" size="large" style="width: 100%">
                    <i class="el-icon-refresh"></i>
                    生成随机分组
                  </el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="result-card" shadow="hover" v-if="groups.length > 0">
              <div slot="header" class="clearfix">
                <span>分组结果</span>
                <el-button
                  type="success"
                  size="small"
                  @click="copyResults"
                  class="copy-btn"
                >
                  <i class="el-icon-document-copy"></i>
                  复制结果
                </el-button>
              </div>
              <div class="groups-result">
                <div
                  v-for="(group, index) in groups"
                  :key="index"
                  class="group-item"
                >
                  <div class="group-header">
                    <el-tag :type="getGroupColor(index)">
                      第 {{ index + 1 }} 组
                    </el-tag>
                    <span class="group-count">({{ group.length }} 人)</span>
                  </div>
                  <el-scrollbar height="150px" class="group-players">
                    <div
                      v-for="(player, pIndex) in group"
                      :key="pIndex"
                      class="player-item"
                    >
                      <i class="el-icon-user"></i>
                      <span>{{ player }}</span>
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </el-card>
            <el-empty
              v-else
              description="点击生成随机分组按钮查看结果"
              class="empty-result"
            ></el-empty>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RandomGroup',
  data() {
    return {
      groupForm: {
        players: '',
        groupCount: 2
      },
      groupRules: {
        players: [
          { required: true, message: '请输入选手名称', trigger: 'blur' },
          { validator: this.validatePlayers, trigger: 'blur' }
        ],
        groupCount: [
          { required: true, message: '请输入分组数量', trigger: 'blur' },
          { type: 'number', min: 1, max: 20, message: '分组数量在 1 到 20 之间', trigger: 'blur' }
        ]
      },
      groups: [],
      loading: false
    }
  },
  methods: {
    // 验证选手数量
    validatePlayers(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入选手名称'))
        return
      }
      const players = value.split('\n').filter(p => p.trim())
      if (players.length < 2) {
        callback(new Error('至少需要 2 名选手'))
        return
      }
      callback()
    },
    // 生成随机分组
    generateGroups() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 解析选手列表
          const players = this.groupForm.players.split('\n')
            .map(p => p.trim())
            .filter(p => p)
          
          // 深拷贝并打乱顺序
          const shuffled = [...players].sort(() => Math.random() - 0.5)
          
          // 计算每组人数
          const groupCount = this.groupForm.groupCount
          const baseSize = Math.floor(shuffled.length / groupCount)
          const remainder = shuffled.length % groupCount
          
          // 生成分组
          this.groups = []
          let index = 0
          
          for (let i = 0; i < groupCount; i++) {
            const groupSize = baseSize + (i < remainder ? 1 : 0)
            this.groups.push(shuffled.slice(index, index + groupSize))
            index += groupSize
          }
          
          this.loading = false
        }
      })
    },
    // 获取分组颜色
    getGroupColor(index) {
      const colors = ['primary', 'success', 'warning', 'danger', 'info']
      return colors[index % colors.length]
    },
    // 复制结果
    copyResults() {
      let resultText = ''
      this.groups.forEach((group, index) => {
        resultText += `第 ${index + 1} 组 (${group.length} 人):\n`
        resultText += group.map((player, pIndex) => `${pIndex + 1}. ${player}`).join('\n')
        resultText += '\n\n'
      })
      
      // 复制到剪贴板
      navigator.clipboard.writeText(resultText.trim())
        .then(() => {
          this.$message.success('分组结果已复制到剪贴板')
        })
        .catch(() => {
          this.$message.error('复制失败，请手动复制')
        })
    }
  }
}
</script>

<style scoped>
.random-group-container {
  padding: 20px 0;
}

.random-group-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.random-group-content {
  min-height: 500px;
}

.input-card {
  margin-bottom: 20px;
}

.result-card {
  margin-bottom: 20px;
}

.groups-result {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.group-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.group-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.group-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.group-header .el-tag {
  margin-right: 10px;
}

.group-count {
  font-size: 12px;
  color: #909399;
}

.group-players {
  margin-top: 10px;
}

.player-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 5px;
  background-color: #fff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.player-item:hover {
  background-color: #ecf5ff;
  transform: translateX(5px);
}

.player-item i {
  margin-right: 8px;
  color: #409eff;
}

.copy-btn {
  float: right;
}

.empty-result {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
</style>